import { render, staticRenderFns } from "./PrmAudit.vue?vue&type=template&id=a74544c6&"
import script from "./PrmAudit.vue?vue&type=script&lang=js&"
export * from "./PrmAudit.vue?vue&type=script&lang=js&"
import style0 from "./PrmAudit.vue?vue&type=style&index=0&id=a74544c6&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports